/* eslint-disable import/prefer-default-export */
import { RootState } from 'app/store'
import { createSelector } from '@reduxjs/toolkit'
import { WIDGET_MAP } from 'components/widget/WidgetFactory'

export const selectHasLegacyWidgets = createSelector(
  [(state: RootState) => state.dashboard.dashboardData],
  (dashboardData) => {
    if (dashboardData?.widgets) {
      const hasLegacyWidgets = dashboardData?.widgets?.some((item) => !WIDGET_MAP[item.type])
      return hasLegacyWidgets
    }
    return false
  }
)
